import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorClonesState = (state: RootState) => state.clones;

export const selectorClones = createSelector(
  selectorClonesState,
  (clonesState) => clonesState.clones
);

export const selectorTrandingClones = createSelector(
  selectorClonesState,
  (clonesState) => clonesState.trandingClones
);
